const $window = $(window);
const $header = $('.header');

const MD_MIN_WIDTH: number = 992;
const FPS_INTERVAL: number = 60;
const STICKY_OFFSET: number = 100;

const STICKY_CLASS: string = 'is-sticky';

let lastTop: number = 0;

const header = {
  initialize() {
    if ($header.length && MD_MIN_WIDTH < $window.width()) {
      this.createListeners();
      this.checkStickyHeader($window.scrollTop());
    }
  },

  createListeners() {
    $window.on('scroll:virtual', (e: any, scrollTop: number) => {
      this.checkStickyHeader(scrollTop);
    });
  },

  checkStickyHeader(top: number) {
    if (top === lastTop) {
      return;
    }

    lastTop = top;

    if (top > STICKY_OFFSET && !$header.hasClass(STICKY_CLASS)) {
      $header.addClass(STICKY_CLASS);
    } else if (top <= STICKY_OFFSET && $header.hasClass(STICKY_CLASS)) {
      $header.removeClass(STICKY_CLASS);
    }
  },
};

export default header;
